import DisclosureGuidelineModal from './DisclosureGuidelineModal';

export default DisclosureGuidelineModal;
